document.addEventListener('DOMContentLoaded', function () {
  var carousels = document.querySelectorAll('[data-process-carousel]');

  carousels.forEach(function (carousel) {
    var section = carousel.closest('.process-carousel');
    var track = carousel.querySelector('[data-pc-track]');
    var slides = carousel.querySelectorAll('[data-pc-slide]');
    var prevBtn = carousel.querySelector('[data-pc-prev]');
    var nextBtn = carousel.querySelector('[data-pc-next]');
    var dotsWrap = section.querySelector('[data-pc-dots]');
    var dots = dotsWrap ? dotsWrap.querySelectorAll('[data-pc-dot]') : [];
    var currentIndex = 0;

    if (!slides.length) return;

    function goTo(index) {
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;
      currentIndex = index;
      track.style.transform = 'translateX(-' + (currentIndex * 100) + '%)';

      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === currentIndex);
      });
    }

    prevBtn && prevBtn.addEventListener('click', function () {
      goTo(currentIndex - 1);
    });

    nextBtn && nextBtn.addEventListener('click', function () {
      goTo(currentIndex + 1);
    });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.getAttribute('data-index'), 10));
      });
    });

    // Swipe support for mobile
    var startX = 0;
    var isDragging = false;

    track.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
      isDragging = true;
    }, { passive: true });

    track.addEventListener('touchend', function (e) {
      if (!isDragging) return;
      isDragging = false;
      var endX = e.changedTouches[0].clientX;
      var diff = startX - endX;

      if (Math.abs(diff) > 40) {
        if (diff > 0) {
          goTo(currentIndex + 1);
        } else {
          goTo(currentIndex - 1);
        }
      }
    });

    goTo(0);
  });
});
